var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlanInformationModalClose(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.24731 6.7168V6.7168C5.11604 4.84807 8.14585 4.84807 10.0146 6.7168L23.2671 19.9694C24.2015 20.9037 24.2015 22.4186 23.2671 23.353V23.353C22.3328 24.2874 20.8179 24.2874 19.8835 23.353L3.24731 6.7168Z",
    fill: "#7E92BE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2882 8.40861C24.2225 7.47425 24.2225 5.95935 23.2882 5.02498V5.02498C22.3538 4.09062 20.8389 4.09062 19.9045 5.02498L4.96016 19.9694C4.02579 20.9037 4.0258 22.4186 4.96016 23.353V23.353C5.89452 24.2874 7.40943 24.2874 8.34379 23.353L23.2882 8.40861Z",
    fill: "#7E92BE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlanInformationModalClose);
export default __webpack_public_path__ + "static/media/plan-information-modal-close.815b98b67c0a52765bbb44d48abdea9f.svg";
export { ForwardRef as ReactComponent };